import React, { useEffect, useState } from "react";
import "./Contact_Us.css";
import { Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faMaximize,
  faMinimize,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Black_Btn from "../common_components/common_btn/black_btn/Black_Btn";
import { useNavigate } from "react-router-dom";
import Success_Modal from "../common_components/common_modal/success_modal/Success_Modal";
//import { contactusForm } from '../../../features/contact_us/contactusSlice';
import { contactusForm } from "../../features/contact_us/contactusSlice";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../features/master/masterSlice";
function Contact_Us() {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const handle = useFullScreenHandle();
  const dispatch = useDispatch();

  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const expandMap = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };

  const toggleMap = () => {
    if (!showMap) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setShowMap(true); // Trigger animation
      setTimeout(() => {
        setHideForm(true); // Remove layout space after animation
      }, 1000); // Match CSS duration
    } else {
      setHideForm(false); // Show form again in layout
      setShowMap(false); // Remove map
    }

    if (showMap && handle.active) {
      handle.exit();
    }
  };

  const navigate = useNavigate();

  // const onSubmit = (data) => {

  //     setShowSucsessModal(true)

  //     setTimeout(() => {
  //         navigate("/")
  //     }, 3000);
  // };

  const onSubmit = (data) => {
    dispatch(contactusForm(data));
    console.log("Form Submitted", data);
    setShowSucsessModal(true);
    reset();
    setTimeout(() => {
      navigate("/");
    }, 3000);
  };

  //console.log("dvuhfd",contactusForm);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "CONTACT US", link: "", isActive: true },
  ];

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const mapSrc = `https://www.google.com/maps/embed/v1/view?key=AIzaSyCWt0FnbB9xGeabZoAMIu_c3hsMg1rKctc&center=${app_setup?.lat},${app_setup?.long}&zoom=14&maptype=roadmap`;

  return (
    <section className="Contact_Us">
      <div className="container">
        <div className="Form_section_holder">
          <Row className="justify-content-center">
            <Col xxl={9} xl={9} lg={10} md={11} sm={12}>
              <div className="heading_holder">
                <h4 className="section_title">Contact Us</h4>
              </div>

              {!hideForm && (
                <div
                  className={`Information-client ${
                    showMap ? "slide-out-wrapper" : ""
                  }`}
                >
                  <Row className="me-0 ms-0">
                    <Col
                      xxl={8}
                      xl={8}
                      lg={7}
                      md={12}
                      xs={12}
                      sm={12}
                      className="pe-xl-0 pe-xxl-0 pe-lg-0 pe-md-0 p-0"
                    >
                      <div className="form_holder">
                        <div className="leftdivv">
                          <>
                            <Form>
                              <Form.Group className="input_group mb-4">
                                <Form.Control
                                  type="text"
                                  placeholder="Your Name"
                                  {...register("name", {
                                    required: "Name is required",
                                  })}
                                  className={classNames("", {
                                    "is-invalid": errors?.name,
                                  })}
                                  onKeyDown={(event) => {
                                    if (!/[A-Za-z ]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                                {errors.name && (
                                  <div className="invalid-feedback">
                                    {errors.name.message}
                                  </div>
                                )}
                              </Form.Group>

                              <Form.Group className="input_group mb-4">
                                <Form.Control
                                  type="email"
                                  placeholder="E-mail Address"
                                  {...register("email", {
                                    required: "Email Id required",
                                    pattern: {
                                      value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                      message: "Email Id Invalid",
                                    },
                                  })}
                                  className={classNames("", {
                                    "is-invalid": errors?.email,
                                  })}
                                />
                                {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email.message}
                                  </div>
                                )}
                              </Form.Group>
                              <Form.Group className="input_group mb-4">
                                <Controller
                                  country="in"
                                  className="phone_input"
                                  name="number"
                                  control={control}
                                  rules={{
                                    required: "number is required",
                                    minLength: {
                                      value: 10,
                                      message:
                                        "Number should be at least 10 characters",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <PhoneInput
                                      country="in"
                                      {...field}
                                      onChange={(value) =>
                                        field.onChange(value)
                                      }
                                      type="text"
                                      placeholder="Enter Mobile Number"
                                      maxLength={10}
                                    />
                                  )}
                                />
                                {/* <Controller
                                  name="number"
                                  control={control}
                                  defaultValue=""
                                  rules={{
                                    required: "Mobile number is required",
                                  }}
                                  render={({ field: { onChange, value } }) => (
                                    <PhoneInput
                                      country={"in"}
                                      value={value}
                                      placeholder="Enter Mobile Number"
                                      onChange={onChange}
                                      className={classNames("", {
                                        "is-invalid": errors?.number,
                                      })}
                                      inputProps={{
                                        name: "number",
                                        required: true,
                                        autoFocus: true,
                                      }}
                                    />
                                  )}
                                /> */}
                                {errors.number && (
                                  <div className="invalid-feedback d-block">
                                    {errors.number.message}
                                  </div>
                                )}
                              </Form.Group>

                              <Form.Group className="input_group mb-4">
                                <Form.Control
                                  as="textarea"
                                  {...register("message", {
                                    required: "Message required",
                                  })}
                                  className={classNames("", {
                                    "is-invalid": errors?.message,
                                  })}
                                  rows={4}
                                  placeholder="Your Message"
                                />
                                {errors.message && (
                                  <div className="invalid-feedback">
                                    {errors.message.message}
                                  </div>
                                )}
                              </Form.Group>
                            </Form>

                            <div className="btndiv">
                              <Black_Btn
                                btnText={"Submit"}
                                onClick={handleSubmit(onSubmit)}
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </Col>

                    <Col
                      xxl={4}
                      xl={4}
                      lg={5}
                      md={12}
                      sm={12}
                      xs={12}
                      className="ps-xxl-0 ps-xl-0 ps-lg-0 ps-md-0 p-0"
                    >
                      <div className="leftdivv1">
                        <div className="d-flex align-items-center information my-4">
                          <div className="fonticndiv">
                            <FontAwesomeIcon icon={faPhone} className="icon" />
                          </div>
                          <p className="text mb-0">{app_setup?.contact_no}</p>
                        </div>
                        <div className="d-flex align-items-center  information my-4">
                          <div className="fonticndiv">
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className="icon"
                            />
                          </div>
                          <p className="text mb-0">{app_setup?.email}</p>
                        </div>
                        <div className="d-flex align-items-center  information my-4">
                          <div className="fonticndiv">
                            <FontAwesomeIcon
                              icon={faMapLocationDot}
                              className="icon"
                            />
                          </div>
                          <p
                            className="text text-decoration-underline cursor-pointer"
                            onClick={toggleMap}
                          >
                            Find Us on map
                          </p>
                        </div>
                        <div className="d-flex align-items-center  information my-4">
                          <div className="fonticndiv">
                            <FontAwesomeIcon
                              icon={faLocationDot}
                              className="icon"
                            />
                          </div>
                          <p className="text mb-0">{app_setup?.address}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
          </Row>
          
          {/* <Row className="justify-content-center">
            <Col xxl={9} xl={9} lg={10} md={11} sm={12}>
              <FullScreen handle={handle}>
                <div
                  className={`map ${!showMap ? "hidden" : "show"} ${
                    handle.active ? "fullscreen" : ""
                  }`}
                >
                  <iframe
                    className="gmap_iframe"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
                    title="Google Map"
                  ></iframe>
                  <div className="close">
                    <div className="map-icons">
                      <FontAwesomeIcon
                        icon={handle.active ? faMinimize : faMaximize}
                        className="map_icon expand"
                        onClick={expandMap}
                      />
                      <FontAwesomeIcon
                        icon={faCircleXmark}
                        className="map_icon close-icon"
                        onClick={toggleMap}
                      />
                    </div>
                  </div>
                </div>
              </FullScreen>
            </Col>
          </Row> */}

          <Row className="justify-content-center">
            <Col xxl={9} xl={9} lg={10} md={11} sm={12}>
              <FullScreen handle={handle}>
                <div
                  className={`map ${!showMap ? "hidden" : "show"} ${
                    handle.active ? "fullscreen" : ""
                  }`}
                >
                  <iframe
                    className="gmap_iframe"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    src={mapSrc}
                    title="Google Map"
                  ></iframe>
                  <div className="close">
                    <div className="map-icons">
                      <FontAwesomeIcon
                        icon={handle.active ? faMinimize : faMaximize}
                        className="map_icon expand"
                        onClick={expandMap}
                      />
                      <FontAwesomeIcon
                        icon={faCircleXmark}
                        className="map_icon close-icon"
                        onClick={toggleMap}
                      />
                    </div>
                  </div>
                </div>
              </FullScreen>
            </Col>
          </Row>
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Enquiry Submitted !"
      />
    </section>
  );
}

export default Contact_Us;
